import { EventEmitter } from "events";
import { urls } from "../config/url";
import { updateFixSteps } from "../redux/progress/fixProgressSteps/fixStepAction";
import { IFixStep } from "../redux/progress/fixProgressSteps/fixStepReducer";
import { job2update } from "../redux/progress/job2/job2Action";
import { IJob2, IJob2s } from "../redux/progress/job2/job2Interface";
import { IModuleParams } from "../redux/progress/param/paramReducer";
import { updateProgressSteps } from "../redux/progress/progressSteps/progressStepAction";
import { IProgressStep } from "../redux/progress/progressSteps/progressStepReducer";
import store from "../redux/store";

class HeartCheck {
    timeout = 3000;
    interval = 2000;
    sendFun: (value: string) => void;
    onTimeOut: () => void;

    createTimeout: number

    constructor(sendFun: (value: string) => void, onTimeOut: () => void) {
        this.sendFun = sendFun;
        this.onTimeOut = onTimeOut;

        this.sendFun("ping");
        this.createTimeout = window.setTimeout(this.handleTimeOut, this.timeout);
    }

    ping() {
        window.setTimeout(() => {
            this.sendFun("ping");
            this.createTimeout = window.setTimeout(this.handleTimeOut, this.timeout);
        }, this.timeout);

    }

    handleTimeOut = () => {
        this.onTimeOut();
    }

    handlePong() {
        clearTimeout(this.createTimeout);
        this.ping();
    }

}

export interface IMonitorProgressService extends IJob2 {
    PARAMS: IModuleParams;
    PRO_MODULE_NAME: string;
    SUBMIT_TIME: number;
    status: number;
}

export interface IMonitorService {
    payload: IJob2s;
    process: {
        [key: string]: IMonitorProgressService;
    };
    fixprocess: {
        [key: string]: IMonitorProgressService;
    };
}

class MonitorService extends EventEmitter {
    constructor(url: string) {
        super();
        this.start(url);
    }

    ws: null | WebSocket = null;
    connecting = false;
    lastTry = false;

    heartCheck: HeartCheck | null = null;

    start = (url: string) => {
        this.connecting = true;
        this.ws = new WebSocket(url);
        this.ws.onopen = () => {
            this.lastTry = true;
            if (this.ws) {
                this.heartCheck = new HeartCheck((msg: string) => {
                    if (this.ws)
                        this.ws.send(msg)
                }, () => {
                    if (this.ws) {
                        this.ws.close();
                    }
                });
            }
        }

        this.ws.onclose = () => {
            if (this.connecting) {
                if (this.lastTry) {
                    this.lastTry = false;
                    window.setTimeout(this.start, 0, url);
                } else {
                    window.setTimeout(this.start, 3000, url);
                }

            }
        }

        this.ws.onmessage = (msg) => {
            if (this.heartCheck && msg.data === 'ok') {
                this.heartCheck.handlePong();
                return;
            }
            const message: any = JSON.parse(msg.data)
            message.payload = message.payload || {};

            message.payload.SEND_ID = message.SEND_ID

            store.dispatch(job2update(message.payload));

            // progress step
            const progressSteps: IProgressStep[] = [];

            for (const mid in message.process) {
                if (Object.prototype.hasOwnProperty.call(message.process, mid)) {
                    const element = message.process[mid];
                    progressSteps.push({
                        moduleName: element.PRO_MODULE_NAME,
                        params: element.PARAMS,
                        timeStamp: element.SUBMIT_TIME,
                        status: element.status,
                        mid: mid,
                    })
                }
            }
            progressSteps.sort((a, b) => {
                return a.timeStamp - b.timeStamp
            })
            store.dispatch(updateProgressSteps(progressSteps));

            // fix step

            const fixSteps: IFixStep[] = [];

            for (const mid in message.fixprocess) {
                if (Object.prototype.hasOwnProperty.call(message.fixprocess, mid)) {
                    const element = message.fixprocess[mid];
                    fixSteps.push({
                        moduleName: element.PRO_MODULE_NAME,
                        params: element.PARAMS,
                        timeStamp: element.SUBMIT_TIME,
                        status: element.status,
                        mid: mid,
                    })
                }
            }
            fixSteps.sort((a, b) => {
                return a.timeStamp - b.timeStamp
            })
            store.dispatch(updateFixSteps(fixSteps));

        }
    }

    stop() {
        this.connecting = false;
        if (this.ws) {
            this.ws.close();
        }
    }



}


export let monitorService: MonitorService | null = null;


export function startMonitor(userName: string, projectName: string, activeLine: string, spec: string, tech: string): () => void {
    const url = urls.jobMonitor + '?'
        + "USER_NAME=" + userName + "&"
        + "PROJECTNAME=" + projectName + "&"
        + "proj_name=" + activeLine + "&"
        + "PRO_MODULE_CLASS=" + spec + "&"
        + "PRO_MODULE_CATEGORY=" + tech + "&"
        + "token=" + store.getState().user.token;

    if (monitorService) {
        monitorService.stop();
    }

    monitorService = new MonitorService(url);

    return monitorService ? monitorService.stop : () => { };

}

export const stopMonitor = () => {
    monitorService?.stop();
}